export function useBetaChecker() {
  // NOTE: [28/11/2023] [kevinz] -> this tool is used in route guard in order to disable beta mode (when there is one in development) when
  //  certain conditions met. For example we may want to disable a beta mode for SH subscriptions...

  const disableBetaIfNeeded = async () => {
    return;
  };
  return { disableBetaIfNeeded };
}
